import { toast } from 'react-toastify'

export const errorHandler = (error: any) => {
  console.error('Error: ', error)
  if (process.env.REACT_APP_IS_PROD === '0') {
    toast.error(error.message)
  }
}
